(function ($) {
  // Chatbot disabled
  return;

  $(document).ready(function () {

    var styleOptions = {
      botAvatarInitials: "A",
      hideUploadButton: true,
      accent: "#8bc53f",
      userAvatarBackgroundColor: "#8bc53f",
      botAvatarImage: (window.chatbotConfig && window.chatbotConfig.avatarUrl) || '',
      paddingRegular: 14,
      paddingWide: 14 * 2,
      sendBoxHeight: 50
    };

    var store;
    var surveyCookieName = 'mcb_survey';

    function initBot() {
      store = window.WebChat.createStore({}, function (_ref) {
        var dispatch = _ref.dispatch;
        return function (next) {
          return function (action) {
            if (action.type === "DIRECT_LINE/CONNECT_FULFILLED") {
              dispatch({
                type: 'DIRECT_LINE/POST_ACTIVITY_PENDING',
                meta: { method: 'keyboard' },
                payload: {
                  activity: {
                    from: { role: "bot" },
                    text: "Hello I'm Andi MAIC's virtual assistant, I'm here to try and answer some of your CTP related questions.\n\nOur chat today will be used to improve my knowledge so please do not enter any personal information.\n\nPlease ask me only one short CTP related question at a time to avoid confusing me.\n\nHow can I help you?",
                    textFormat: "markdown",
                    timestamp: new Date().toString(),
                    type: "message"
                  }
                }
              });
            }
            if (action.type === 'DIRECT_LINE/POST_ACTIVITY') {
              action = window.simpleUpdateIn(action, ['payload', 'activity', 'channelData', 'url'], function() { return window.location.hostname; });
            }
            return next(action);
          };
        };
      });
      window
        .fetch('https://maicqa-app-plan.azurewebsites.net/directline/token', { method: 'GET' })
        .then(function (res) {
          return res.json();
        })
        .then(function (json) {
          var token = json.token;

          window.WebChat.renderWebChat(
            {
              directLine: window.WebChat.createDirectLine({
                token: token
              }),
              store: store,
              styleOptions: styleOptions
            },
            document.getElementById("webchat")
          );
          document.querySelector("#webchat > *").focus();
        })
        .catch(function(err){console.error(err);});
    }

    function init() {
      var webchaticon = document.getElementById('webchaticon');
      if (webchaticon) {
        webchaticon.addEventListener("click", startbot);
      }
      var webchatClose = document.getElementById('webchatClose');
      if (webchatClose) {
        webchatClose.addEventListener("click", checkSurvey);
      }

      var webchatAcceptSurvey = document.getElementById('webchatAcceptSurvey');
      if (webchatAcceptSurvey) {
        webchatAcceptSurvey.addEventListener("click", acceptSurvey);
      }

      var webchatRejectSurvey = document.getElementById('webchatRejectSurvey');
      if (webchatRejectSurvey) {
        webchatRejectSurvey.addEventListener("click", rejectSurvey);
      }

      setTimeout(function () {
        var icon = document.getElementById("webchatintro");
        if (icon) {
          icon.classList.add("hide");
        }
      }, 20000);
    }

    function closebot() {
      var holder = document.getElementById("webchatholder");
      holder.classList.remove("open");
    }
    function showbot() {
      var holder = document.getElementById("webchatholder");
      holder.classList.add("open");
    }
    function startbot() {
      showbot();

      var bot = document.getElementById("webchat");
      if (bot && !bot.classList.contains("ready")) {
        bot.classList.add("ready");
        var icon = document.getElementById("webchatintro");
        icon.classList.add("hide");
        initBot();
      }
    }

    function checkSurvey() {
      var asked = getCookie(surveyCookieName);
      asked = true; //DISABLED SURVEYS
      if (asked) {
        closebot();
      } else {
        askSurvey();
      }
    }

    function askSurvey() {
      var survey = document.getElementById("webchatsurvey");
      survey.classList.add("open");
      setCookie(surveyCookieName, 'survey', 30);
    }

    function rejectSurvey() {
      var survey = document.getElementById("webchatsurvey");
      survey.classList.remove("open");
      closebot();
    }

    function acceptSurvey() {
      var survey = document.getElementById("webchatsurvey");
      survey.classList.remove("open");
      store.dispatch({
        type: "WEB_CHAT/SEND_POST_BACK",
        payload: {
          value: 'survey'
        }
      });
    }

    function setCookie(name, value, days) {
      var expires = "";
      if (days) {
        var date = new Date();
        date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
        expires = "; expires=" + date.toUTCString();
      }
      document.cookie = name + "=" + (value || "") + expires + "; path=/";
    }

    function getCookie(name) {
      var nameEQ = name + "=";
      var ca = document.cookie.split(';');
      for (var i = 0; i < ca.length; i++) {
        var c = ca[i];
        while (c.charAt(0) == ' ') c = c.substring(1, c.length);
        if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length, c.length);
      }
      return null;
    }

    init();

  });
})(jQuery);
